import type { FetchResult } from "./opsPaperworkClientBase";
import { opsFetch, q } from "./opsPaperworkClientBase";

export type OpsDriveSecretStatus = {
  ok: true;
  configured: boolean;
  client_email: string | null;
  updated_at: string | null;
  encryption_configured: boolean;
  env_fallback: boolean;
};

export async function getOpsGoogleDriveSecret(): Promise<FetchResult<OpsDriveSecretStatus>> {
  return opsFetch(q("google-drive-secret"));
}

export async function postOpsGoogleDriveSecret(
  serviceAccountJson: string
): Promise<FetchResult<{ ok: true; saved: true; client_email?: string }>> {
  return opsFetch(q("google-drive-secret"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ service_account_json: serviceAccountJson }),
  });
}

export async function postOpsGoogleDriveBuildFolders(
  template: string
): Promise<FetchResult<{ ok: true; created: number; paths: string[]; folder_url?: string; message: string }>> {
  return opsFetch(q("google-drive-build-folders"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ template }),
  });
}

export type OpsDriveResortResult = {
  ok: true;
  dry_run: boolean;
  checked?: number;
  moved?: number;
  skipped?: number;
  remaining?: number;
  message: string;
  samples?: Array<{ deal_id: string; display_name: string | null; path?: string; moved?: boolean }>;
};

export async function postOpsGoogleDriveResortFolders(
  template: string,
  dryRun: boolean
): Promise<FetchResult<OpsDriveResortResult>> {
  return opsFetch(q("google-drive-resort"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ template, dry_run: dryRun }),
  });
}

export async function clearOpsGoogleDriveSecret(): Promise<FetchResult<{ ok: true; cleared: true }>> {
  return opsFetch(q("google-drive-secret"), { method: "DELETE" });
}
